import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './AppFlow.css';

const AppFlow = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('customer');

  const customerSteps = [
    { num: '01', title: t('flowCustomer1Title'), desc: t('flowCustomer1Desc'), icon: '✦' },
    { num: '02', title: t('flowCustomer2Title'), desc: t('flowCustomer2Desc'), icon: '◆' },
    { num: '03', title: t('flowCustomer3Title'), desc: t('flowCustomer3Desc'), icon: '❋' },
    { num: '04', title: t('flowCustomer4Title'), desc: t('flowCustomer4Desc'), icon: '✿' },
  ];

  const businessSteps = [
    { num: '01', title: t('flowBusiness1Title'), desc: t('flowBusiness1Desc'), icon: '✦' },
    { num: '02', title: t('flowBusiness2Title'), desc: t('flowBusiness2Desc'), icon: '◆' },
    { num: '03', title: t('flowBusiness3Title'), desc: t('flowBusiness3Desc'), icon: '❋' },
    { num: '04', title: t('flowBusiness4Title'), desc: t('flowBusiness4Desc'), icon: '✿' },
  ];

  const steps = activeTab === 'customer' ? customerSteps : businessSteps;

  return (
    <section id="how-it-works" className="app-flow" aria-label={t('howItWorks')}>
      <div className="app-flow-blob app-flow-blob--left" aria-hidden="true" />
      <div className="app-flow-blob app-flow-blob--right" aria-hidden="true" />
      <div className="container">
        <p className="section-eyebrow">{t('howItWorks')}</p>
        <h2 className="section-title">{t('appFlowTitle')}</h2>
        <p className="section-subtitle">{t('appFlowDescription')}</p>

        <div className="flow-tabs" role="tablist" aria-label={t('appFlowTitle')}>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === 'customer'}
            className={`flow-tab ${activeTab === 'customer' ? 'active' : ''}`}
            onClick={() => setActiveTab('customer')}
          >
            {t('flowCustomerTab')}
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === 'business'}
            className={`flow-tab ${activeTab === 'business' ? 'active' : ''}`}
            onClick={() => setActiveTab('business')}
          >
            {t('flowBusinessTab')}
          </button>
        </div>

        <div className="flow-grid" role="tabpanel">
          {steps.map((step, index) => (
            <article key={step.num} className="flow-step" style={{ '--step-delay': `${index * 0.08}s` }}>
              <div className="flow-step-icon" aria-hidden="true">{step.icon}</div>
              <span className="flow-step-num">{step.num}</span>
              <h3 className="flow-step-title">{step.title}</h3>
              <p className="flow-step-desc">{step.desc}</p>
            </article>
          ))}
        </div>

        <div className="flow-connector" aria-hidden="true">
          <span /><span /><span />
        </div>
      </div>
    </section>
  );
};

export default AppFlow;
